export default "__VITE_ASSET__BZZFYkPK__"